import * as React from 'react';
import { DesktopSignInForm } from '../../components/forms/desktop-sign-in-form/desktop-sign-in-form.component';
import { PageMeta } from '../../components/page-meta';
import { AuthPageLayout } from '../../ui/layout/auth-page-layout/auth-page-layout.component';

export const DesktopSignIn: React.FC = () => {
  return (
    <AuthPageLayout>
      <PageMeta title="ui-desktop-signed-out" description="ui-desktop-signed-out-description" />
      <DesktopSignInForm />
    </AuthPageLayout>
  );
};
